/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * User client setting DTO.
 */
export interface UserClientSettingDto {
  /**
   * Settings key.
   */
  key: string;
  /**
   * Value of settings key.
   */
  value: string;
}
